<template>
    <div class="container">
        <div class="col-12 profile p-3">
            <div class="bg-white br bs">
                <div class="profile__header">
                    <img class="br" src="@/assets/img/img-1.jpg" alt="Background">
                    <div class="profile__avatar">
                        <img :src="dataUser.photo_profile || '@/assets/img/hopper.jpg'" alt="Avatar">
                    </div>
                </div>
                <div class="d-flex flex-column text-center">
                    <div class="profile__info p-4">
                        <h2>Edit Profile</h2>
                    </div>
                    <div class="px-3 pb-3 col-12 col-lg-3 col-md-3 col-sm-12 offset-lg-9 offset-md-9">
                        <p class="m-0">Upload Photo Profile</p>
                        <b-form-file v-model="file" ref="file" placeholder="" size="2M" accept=".jpg, .png, .jpeg" @change="uploadPhotoProfile"></b-form-file>
                    </div>
                </div>
            </div>
        </div>
        <div class="row p-3 align-items-start">
            <div class="col-12 newsfeed">
                <div class="d-flex flex-column">
                    <div class="card">
                        <div class="card__content">
                            <div class="row px-3 py-2">
                                <div class="col-md-12">
                                    <div role="group">
                                        <label for="full_name">Full Name:</label>
                                        <b-form-input
                                            id="full_name"
                                            v-model="form.full_name"
                                            type="text"
                                            placeholder="Enter your full name"
                                            @change="updateProfile('full_name')"
                                        ></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="row px-3 py-2">
                                <div class="col-md-12">
                                    <div role="group">
                                        <label for="email">Email:</label>
                                        <b-form-input
                                            id="email"
                                            v-model="form.email"
                                            type="email"
                                            disabled
                                        ></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="row px-3 py-2">
                                <div class="col-md-6 col-sm-12">
                                    <div role="group">
                                        <label for="origin_country">Origin Country:</label>
                                        <b-form-input
                                            id="origin_country"
                                            v-model="form.origin_country"
                                            type="text"
                                            placeholder="Enter your origin country"
                                            @change="updateProfile('origin_country')"
                                        ></b-form-input>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div role="group">
                                        <label for="passport_no">Passport No:</label>
                                        <b-form-input
                                            id="passport_no"
                                            v-model="form.passport_no"
                                            type="text"
                                            placeholder="Enter your passport no"
                                            @change="updateProfile('passport_no')"
                                        ></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="row px-3 py-2">
                                <div class="col-md-6 col-sm-12">
                                    <div role="group">
                                        <label for="birthdate">Birthdate:</label>
                                        <date-picker id="birthdate" v-model="form.birthdate" :config="options" placeholder="Enter your birthdate" @change="    updateProfile('birthdate')"></date-picker>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <b-form-radio-group
                                        v-model="form.hide_birthdate"
                                        :options="optionsRadioBirthdate"
                                        buttons
                                        button-variant="outline-primary"
                                        size="sm"
                                        name="radio-btn-outline"
                                        @input="updateProfile('hide_birthdate')"
                                  ></b-form-radio-group>
                                </div>
                            </div>
                            <div class="row px-3 py-2">
                                <div class="col-md-6 col-sm-12">
                                    Select your gender : 
                                    <b-form-radio-group
                                        v-model="form.gender"
                                        :options="optionsGender"
                                        buttons
                                        button-variant="outline-primary"
                                        size="sm"
                                        name="radio-btn-outline"
                                        @input="updateProfile('gender')"
                                    ></b-form-radio-group>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <b-form-radio-group
                                        v-model="form.hide_gender"
                                        :options="optionsRadioGender"
                                        buttons
                                        button-variant="outline-primary"
                                        size="sm"
                                        name="radio-btn-outline"
                                        @input="updateProfile('hide_gender')"
                                    ></b-form-radio-group>
                                </div>
                            </div>
                            <div class="row px-3 py-2">
                                <div class="col-md-6 col-sm-12">
                                    <div role="group">
                                        <label for="phone_number">Phone Number:</label>
                                        <vue-tel-input id="phone_number" v-model="form.phone_number" @input="updateProfile('phone_number')"></vue-tel-input>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <b-form-radio-group
                                        v-model="form.hide_phone_number"
                                        :options="optionsRadioPhoneNumber"
                                        buttons
                                        button-variant="outline-primary"
                                        size="sm"
                                        name="radio-btn-outline"
                                        @input="updateProfile('hide_phone_number')"
                                    ></b-form-radio-group>
                                </div>
                            </div>
                            <div class="row px-3 py-2">
                                <div class="col-md-6 col-sm-12">
                                    <div role="group">
                                        <label for="darmasiswa_academic_year">Darmasiswa Academic Year:</label>
                                        <b-form-select id="darmasiswa_academic_year" v-model="form.darmasiswa_academic_year" :options="optionsDarmasiswaAcademicYear" @change="updateProfile('darmasiswa_academic_year')"></b-form-select>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div role="group">
                                        <label for="field_study">Field Study:</label>
                                        <b-form-select id="field_study" v-model="form.field_study" :options="optionsFieldsStudy" @change="updateProfile('field_study')"></b-form-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row px-3 py-2">
                                <div class="col-md-12">
                                    <div role="group">
                                        <label for="university">University:</label>
                                        <b-form-input
                                            id="university"
                                            v-model="form.university"
                                            type="text"
                                            placeholder="Enter your university"
                                            @change="updateProfile('university')"
                                        ></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="row px-3 py-2">
                                <div class="col-md-12">
                                    <div role="group">
                                        <label for="interested_in">Interested In:</label>
                                        <b-form-select id="interested_in" v-model="form.interested_in" :options="optionsInterestedIn" @change="updateProfile('interested_in')"></b-form-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input';
const CryptoJS = require("crypto-js");
const config = require('../config/config.js');
const { aes } = config;

export default {
    components: {
        VueTelInput,
    },
    data() {
        return {
            file: '',
            form: {
                full_name: null,
                email: null,
                origin_country: null,
                passport_no: null,
                birthdate: null,
                hide_birthdate: false,
                gender: null,
                hide_gender: false,
                phone_number: null,
                hide_phone_number: false,
                darmasiswa_academic_year: 'default',
                field_study: 'default',
                university: null,
                interested_in: 'default',
            },
            options: {
                format: 'DD/MM/YYYY',
                useCurrent: false,
                showClear: true,
                showClose: true,
            },
            optionsRadioBirthdate: [
                { text: 'Show', value: 1 },
                { text: 'Hide', value: 0 },
            ],
            optionsRadioGender: [
                { text: 'Show', value: 1 },
                { text: 'Hide', value: 0 },
            ],
            optionsRadioPhoneNumber: [
                { text: 'Show', value: 1 },
                { text: 'Hide', value: 0 },
            ],
            optionsGender: [
                { text: 'Male', value: 'male' },
                { text: 'Female', value: 'female' },
            ],
            optionsDarmasiswaAcademicYear: [
                { value: 'default', text: 'Plese select your darmasiswa academic year', disabled: true },
                { value: '1974/1975', text: '1974/1975' },
                { value: '1975/1976', text: '1975/1976' },
                { value: '1976/1977', text: '1976/1977' },
                { value: '1977/1978', text: '1977/1978' },
                { value: '1978/1979', text: '1978/1979' },
                { value: '1979/1980', text: '1979/1980' },
                { value: '1980/1981', text: '1980/1981' },
                { value: '1981/1982', text: '1981/1982' },
                { value: '1982/1983', text: '1982/1983' },
                { value: '1983/1984', text: '1983/1984' },
                { value: '1984/1985', text: '1984/1985' },
                { value: '1985/1986', text: '1985/1986' },
                { value: '1986/1987', text: '1986/1987' },
                { value: '1987/1988', text: '1987/1988' },
                { value: '1988/1989', text: '1989/1990' },
                { value: '1989/1990', text: '1989/1990' },
                { value: '1990/1991', text: '1989/1990' },
                { value: '1991/1992', text: '1991/1992' },
                { value: '1992/1993', text: '1992/1993' },
                { value: '1993/1994', text: '1993/1994' },
                { value: '1994/1995', text: '1994/1995' },
                { value: '1995/1996', text: '1995/1996' },
                { value: '1996/1997', text: '1996/1997' },
                { value: '1997/1998', text: '1997/1998' },
                { value: '1998/1999', text: '1998/1999' },
                { value: '1999/2000', text: '1999/2000' },
                { value: '2000/2001', text: '2000/2001' },
                { value: '2001/2002', text: '2001/2002' },
                { value: '2002/2003', text: '2002/2003' },
                { value: '2003/2004', text: '2003/2004' },
                { value: '2004/2005', text: '2004/2005' },
                { value: '2005/2006', text: '2005/2006' },
                { value: '2006/2007', text: '2006/2007' },
                { value: '2007/2008', text: '2007/2008' },
                { value: '2008/2009', text: '2008/2009' },
                { value: '2009/2010', text: '2009/2010' },
                { value: '2010/2011', text: '2010/2011' },
                { value: '2011/2012', text: '2011/2012' },
                { value: '2012/2013', text: '2012/2013' },
                { value: '2013/2014', text: '2013/2014' },
                { value: '2014/2015', text: '2014/2015' },
                { value: '2015/2016', text: '2015/2016' },
                { value: '2016/2017', text: '2016/2017' },
                { value: '2017/2018', text: '2017/2018' },
                { value: '2018/2019', text: '2018/2019' },
                { value: '2019/2020', text: '2019/2020' },
            ],
            optionsFieldsStudy: [
                { value: 'default', text: 'Plese select your field study', disabled: true },
                { value: 'Bahasa Indonesia', text: 'Bahasa Indonesia' },
                { value: 'Art/Culture', text: 'Art/Culture' },
            ],
            optionsInterestedIn: [
                { value: 'default', text: 'Plese select your Interest', disabled: true },
                { value: 'Social-Cultural', text: 'Social-Cultural' },
                { value: 'Educations', text: 'Educations' },
                { value: 'Economics', text: 'Economics' },
                { value: 'Politics', text: 'Politics' },
            ],
        }
    },
    computed: {
        isLogin: function () {
            return this.$store.state.isLogin;
        },
        dataUser: function () {
            if (this.isLogin) {
                this.form = this.$store.state.dataUser;
                return this.$store.state.dataUser;
            } else {
                return [];
            }
        },
    },
    created() {
        if (this.isLogin) {
            this.form = this.dataUser;
        }
    },
    methods: {
        async uploadPhotoProfile(event) {
            try {
                const payload = {
                    scope: 'uploadPhotoProfile',
                    data: {
                        access_token: this.dataUser.access_token,
                        photo: event.target.files[0],
                    },
                };

                let user = await this.$store.dispatch('user', payload);
                if (user.data.status) {
                    this.file = '';
                    this.$bvToast.toast('Update Photo Profile Success', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000,
                    });

                    let dataUser = user.data.data; 
                    dataUser.access_token = user.data.access_token;
                    localStorage.setItem('dataUser', CryptoJS.AES.encrypt(JSON.stringify(dataUser), aes));
                    this.$store.commit('setDataUser');
                } else {
                    this.file = '';
                    this.$bvToast.toast('Update Photo Profile Failed. Photo profile size must less than 2 mb and have .jpg, .jpeg, .png format type!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.file = '';
                this.$bvToast.toast('Error occured please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async updateProfile(type) {
            try {
                let payload = {
                    scope: 'updateProfile',
                    data: {
                        access_token: this.dataUser.access_token,
                    },
                };

                payload.data[type] = this.form[type];
                let user = await this.$store.dispatch('user', payload);
                if (user.data.status) {
                    this.$bvToast.toast('Update Profile Success', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000,
                    });

                    let dataUser = user.data.data; 
                    dataUser.access_token = user.data.access_token;
                    localStorage.setItem('dataUser', CryptoJS.AES.encrypt(JSON.stringify(dataUser), aes));
                    this.$store.commit('setDataUser');
                } else {
                    this.$bvToast.toast('Update Profile Failed!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.$bvToast.toast('Error occured please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
    },
}
</script>